export class ApiError extends Error {
  constructor({
    status = 0,
    message = 'Request failed',
    errors = {},
    code = null,
    payload = null,
    isNetworkError = false,
  } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.errors = errors && typeof errors === 'object' ? errors : {};
    this.code = code;
    this.payload = payload;
    this.isNetworkError = isNetworkError;
  }

  get fieldErrors() {
    return this.errors;
  }

  isUnauthorized() {
    return this.status === 401;
  }

  isForbidden() {
    return this.status === 403;
  }

  isNotFound() {
    return this.status === 404;
  }

  isGone() {
    return this.status === 410;
  }

  isBadRequest() {
    return this.status === 400;
  }

  isConflict() {
    return this.status === 409;
  }

  isValidation() {
    return this.status === 422;
  }

  isThrottled() {
    return this.status === 429;
  }

  isStaleRevision() {
    return this.status === 409 && Boolean(this.errors?.current_revision || this.errors?.expected_revision);
  }

  isGenerationInProgress() {
    return this.status === 409 && String(this.errors?.generation_status || '') === 'generating';
  }

  isPayloadTooLarge() {
    return this.status === 413;
  }

  isUnsupportedMedia() {
    return this.status === 415;
  }
}

export function isApiError(error) {
  return error instanceof ApiError;
}
